import { Mark } from "@tiptap/core";

export interface EmojiOptions {
  HTMLAttributes: Record<string, any>;
}

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    smartEmoji: {
      addEmoji: (attributes: string) => ReturnType;
      addCustomEmoji: (attributes: string) => ReturnType;
    };
  }
}

export const SmartEmoji = Mark.create<EmojiOptions>({
  name: "smartEmoji",
  addCommands() {
    return {
      addEmoji:
        (attributes) =>
        ({ chain }) => {
          return chain().insertContent(attributes).run();
        },
    };
  },
});
